import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';
import useTranslateWithFallback from '../../hooks/useTranslateWithFallback';

export type ShoppingCartAsideEmptyProps = StandardDivProps<ShoppingCartAsideEmptyClassKey>;

export type ShoppingCartAsideEmptyClassKey = 'root';

const themeSettings = { name: 'ShoppingCartAsideEmpty' };
const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles<ShoppingCartAsideEmptyClassKey, {}>({
      root: { textAlign: 'center', padding: theme.spacing(2, 0) },
    }),
  themeSettings,
);

const ShoppingCartAsideEmpty = React.forwardRef<HTMLDivElement, ShoppingCartAsideEmptyProps>(
  ({ className, classes: pClasses }, ref) => {
    const classes = useStyles({ classes: pClasses });
    const t = useTranslateWithFallback();

    return (
      <div ref={ref} className={clsx(classes.root, className)}>
        {t('shoppingCart/empty')}
      </div>
    );
  },
);

ShoppingCartAsideEmpty.displayName = 'ShoppingCartAsideEmpty';

export default withThemeProps(themeSettings)(ShoppingCartAsideEmpty);
